import React from 'react'
import adabiyot from "../fayl/ADABIYOTLAR.pdf"
import { Button } from 'antd'

const Adabiyot = () => {
  return (
    <Button className='button'>
        <a href={adabiyot}>Adabiyotlar</a>
    </Button>
  )
}

export default Adabiyot